import React from 'react';
import { useInputStyles } from 'components/UI/V2/Forms/Input/Input.styles';
import clsx from 'clsx';
import { Label } from 'components/UI/V2/Forms/Label/Label';

interface InputProps extends Omit<React.ComponentProps<'input'>, 'size'> {
    label?: string;
    error?: string | null;
    placeholder?: string;
    size?: 'small' | 'medium';
    required?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ label, error, size, required, ...inputProps }, ref) => {
    const classes = useInputStyles();

    const hasValue = React.useMemo(() => ((inputProps?.value as string)?.length || 0) > 0, [inputProps?.value]);

    return (
        <div className={classes.root}>
            {label && (
                <Label
                    required={required}
                    error={error}
                >
                    {label}
                </Label>
            )}

            <input
                ref={ref}
                {...inputProps}
                placeholder={inputProps?.placeholder}
                className={clsx(classes.input, {
                    [classes.inputError]: error,
                    [classes.inputFilled]: hasValue,
                    [classes.small]: size === 'small'
                })}
            />
        </div>
    );
});

Input.displayName = 'Input';

export { Input };
